module.exports = require("deepmerge")(require("./config.default.js"), {
  native: {
    name: {
      default: "MOM_D"
    },
    id: "com.mobilespot.moo.dev",
    // iOS
    appleTeamId: "2BAP3P29V2",
    // iosAppStoreUrl: 'https://itunes.apple.com/app/id1484463502',
    // Android
    // 'androidapp-id': 'TODO', // unused?
    playStoreUrl: ""
  },
  web: {
    url: "mom0922.ms-dev.mobile-spot.com "
  },
  relatedRepos: [{
    src: "git@bitbucket.org:mobilespotdev/cordova.git",
    postCommands: ["cd cordova && npm install"],
    branch: "inte/mom0922/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo.git",
    postCommands: ["cd mobigeo && npm install"],
    branch: "inte/mom0922/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo-customs-mom-0922",
    branch: "inte/mom0922/main",
    dest: "mobigeo/mobigeo-customs"
  }, {
    src: "git@bitbucket.org:mobilespotdev/app-react.git",
    branch: "inte/mom0922/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/data-mom-0922.git",
    branch: "inte/mom0922/main",
    dest: "app-react/data",
    postCommands: ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
});